import { type BuilderCtx, CAP, type Collection } from './shared.ts'
import { sortByStale } from '../filter.ts'

export const buildFreeRow = ({ activities }: BuilderCtx): Collection => ({
	key: 'free',
	title: 'Free days out',
	activities: activities
		.filter((a) => a.cost === 'free')
		.sort(sortByStale)
		.slice(0, CAP),
	seeAll: { costs: ['free'] },
})
